import Vue from "vue";
import VueRouter from "vue-router";
import router from "./routes/routes";
import { createPinia, PiniaVuePlugin } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import App from "./App.vue";
import { useLoginStore } from "./stores/loginStore.js";
import { useNotificationStore } from "./stores/notificationStore.js";
import "./assets/styles/global.css";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "bootstrap-vue/dist/bootstrap-vue.css";
import './plugins/fontawesome';
import VueFeather from 'vue-feather';
import { App as CapacitorApp } from '@capacitor/app';
import VueQrcodeReader from 'vue-qrcode-reader'

Vue.component('VueFeather', VueFeather);

Vue.use(VueRouter);
Vue.use(PiniaVuePlugin);
Vue.use(ElementUI);
Vue.use(VueQrcodeReader);

const pinia = createPinia();
pinia.use(createPersistedState({ storage: localStorage }));
Vue.use(pinia);

const loginStore = useLoginStore(pinia);
const notificationStore = useNotificationStore(pinia);
Vue.prototype.$store = loginStore;
Vue.prototype.$notificationStore = notificationStore;

new Vue({
    el: "#app",
    render: h => h(App),
    router,
    pinia,
    async created() {
        CapacitorApp.addListener('backButton', async () => {
            router.go(-1);
        });
        
        try {
            await notificationStore.initializePushNotifications();
            console.log('Push notifications initialized in main.js');
        } catch (error) {
            console.error('Failed to initialize push notifications in main.js:', error);
        }
    }
});
